/* HMB Animations v4 */

/* Scroll reveal for logo section */
;(function() {
  function initScrollAnimations() {
    var logoSection = document.querySelector('[id$="__logo_finale"]')
    if (logoSection) {
      var imageBlock = logoSection.querySelector('.image-block')
      if (imageBlock) imageBlock.classList.add('hmb-scroll-reveal')
    }
    var targets = document.querySelectorAll('.hmb-scroll-reveal')
    if (!targets.length) return
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) { entry.target.classList.add('hmb-revealed'); observer.unobserve(entry.target) }
      })
    }, { threshold: 0.2 })
    targets.forEach(function(el) { observer.observe(el) })
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollAnimations)
  } else {
    initScrollAnimations()
  }
})();

/* WhatsApp floating button con mensaje dinámico */
;(function() {
  function getPageName(type) {
    // 1. h1 text (most reliable on Shopify)
    var h1 = document.querySelector('h1')
    if (h1 && h1.textContent.trim()) return h1.textContent.trim()
    // 2. ShopifyAnalytics meta
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta
      if (type === 'product' && meta && meta.product && meta.product.title) return meta.product.title
    } catch(e) {}
    // 3. URL slug as last resort
    var path = window.location.pathname
    var segment = type === 'product'
      ? path.split('/products/')[1]
      : path.split('/collections/')[1]
    if (segment) {
      var slug = segment.split('?')[0].replace(/-/g, ' ')
      return slug.charAt(0).toUpperCase() + slug.slice(1)
    }
    return type === 'product' ? 'este producto' : 'esta categoría'
  }

  function getWhatsAppMessage() {
    var path = window.location.pathname
    if (path.indexOf('/products/') !== -1) {
      return '¡Hola! Estoy viendo ' + getPageName('product') + ' y tengo una pregunta 🌸 ¿Pueden ayudarme?'
    }
    if (path.indexOf('/collections/') !== -1) {
      return '¡Hola! Estoy viendo ' + getPageName('collection') + ' y me gustaría saber más 🌸 ¿Pueden ayudarme?'
    }
    return '¡Hola! Estoy interesada en los productos de Holie Marie Beauty 🌸 ¿Pueden ayudarme?'
  }

  function addWhatsAppButton() {
    if (document.getElementById('hmb-whatsapp')) return
    var a = document.createElement('a')
    a.id = 'hmb-whatsapp'
    a.className = 'hmb-whatsapp-btn'
    a.target = '_blank'
    a.rel = 'noopener noreferrer'
    a.setAttribute('aria-label', 'Chatea con nosotras en WhatsApp')
    a.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" fill="#fff"/></svg>'
    // Actualizar href con mensaje dinámico al hacer click
    a.addEventListener('click', function() {
      var msg = encodeURIComponent(getWhatsAppMessage())
      a.href = 'https://wa.me/50670333413?text=' + msg
    })
    // También setear el href inicial
    a.href = 'https://wa.me/50670333413?text=' + encodeURIComponent(getWhatsAppMessage())
    document.body.appendChild(a)
    var tip = document.createElement('div')
    tip.className = 'hmb-whatsapp-tooltip'
    tip.textContent = '¡Chatea con nosotras!'
    document.body.appendChild(tip)
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addWhatsAppButton)
  } else {
    addWhatsAppButton()
  }
})();
